export const createServices = () => ({});

export type Services = ReturnType<typeof createServices>;
